import React, { useState, useEffect } from 'react';
import BrainDiagram from '../BrainDiagram';
import { Image } from 'react-bootstrap';
import GooglePlay from '../../images/google-play.png';
import AppStore from '../../images/appstore-logo.png';
import MyProfileModal from './MyProfileModal';

const MiddleSection = ({ formData, showResults, onCalculatedValues, isReset }) => {
  const [showProfileModal, setShowProfileModal] = useState(false);

  const handleClose = () => {
    setShowProfileModal(false);
  };

  useEffect(() => {
    if (isReset && onCalculatedValues) {
      onCalculatedValues({});
    }
  });
  const goToAppStore = () => {
    window.open("https://apps.apple.com/us/app/ez1020/id6748396079", "_blank");
  };
  const goToPlaystore = () => {
    window.open("https://play.google.com/store/apps/details?id=com.ezguide", "_blank");
  };

  return (
    <div className="d-flex flex-column h-100 head-wrapper-img">
      <div className="d-flex justify-content-end">
        <button className="btn blue-btn d-flex align-items-center gap-2" onClick={() => setShowProfileModal(true)}>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="16" fill="white" />
            <circle cx="16" cy="12" r="4" fill="#1C75BC" stroke="#1C75BC" strokeWidth="1.5" />
            <circle cx="16.0001" cy="16" r="13.3333" stroke="#1C75BC" strokeWidth="1.5" />
            <path
              d="M23.9589 26.6667C23.7467 22.8113 22.5663 20 15.9999 20C9.43361 20 8.25321 22.8113 8.04102 26.6667"
              stroke="#1C75BC"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
          My Profile
        </button>
      </div>
      <div className="flex-grow-1 d-flex justify-content-center align-items-center">
        <BrainDiagram formData={formData} onCalculatedValues={onCalculatedValues} />
      </div>
      <div className="d-block align-self-end btns-app">
        <div className="app-buttons d-block">
          <Image src={GooglePlay} style={{ cursor: "pointer" }} onClick={goToPlaystore} alt="playstore" className="d-block" />
          <Image src={AppStore} style={{ cursor: "pointer" }} onClick={goToAppStore} alt="appstore" className="d-block mt-3" />
        </div>
      </div>
      <MyProfileModal showProfileModal={showProfileModal} onClose={handleClose} />
    </div>
  );
};

export default MiddleSection;